import { tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

/**
 * If `environment.production` is false, display stream events in a color-coded fashion
 * @param tag tag to identify stream
 */
export function debug<T>(tag: string) {
    void tag;
    return tap<T>();
}
